import PropTypes from "prop-types";
import { Table, TBody, TH, THead, TR } from "../../../Reports/components/BusinessDashboard/Table/Table";
import ActivityHistoryRow, { ROW_BORDER } from "./ActivityHistoryRow";
import { useCurrentUser } from "../../../reducers/layoutReducer/selectors";

const ActivityTable = ({ data, onDelete, onUpdate }) => {
  const currentUser = useCurrentUser();
  return (
    <Table className="tw-border-collapse">
      <THead>
        <TR>
          <TH className={ROW_BORDER}>Logged By</TH>
          <TH className={ROW_BORDER}># of Activity</TH>
          <TH className={ROW_BORDER}>Activity Date</TH>
          <TH className={ROW_BORDER} colSpan={3}>
            Notes
          </TH>
        </TR>
      </THead>
      <TBody>
        {data?.map((activity) => (
          <ActivityHistoryRow
            key={activity.id}
            activity={activity}
            isEditable={currentUser.id === activity.user.id}
            onDelete={onDelete}
            onUpdate={onUpdate}
          />
        ))}
      </TBody>
    </Table>
  );
};

ActivityTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onDelete: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

export default ActivityTable;
